export function Brand({ className = '', compact = false }: { className?: string; compact?: boolean }) {
  return <img
    className={`brand-logo ${compact ? 'brand-logo-compact' : ''} ${className}`.trim()}
    src="/branding/kongjitsu-logo.png"
    alt="KongJitsu"
    draggable={false}
  />;
}
